import React from "react";
import useAuthStore from "@/stores/user/authStore";
import { toTitleCase } from "@/lib/general";
import PageHeaderBar from "@/components/common/PageHeaderBar";

const LodgeHeaderBar: React.FC = () => {
  const { user: currentUser, anonymousUser } = useAuthStore();
  const title =
    currentUser?.first_name && !anonymousUser
      ? `${toTitleCase(currentUser.first_name)}'s Lodge`
      : "The Lodge";

  return <PageHeaderBar title={"Lodge"} />;
};

export default LodgeHeaderBar;
